export default __webpack_public_path__ + "static/media/welcome-bonus-ico.ea48fc62.svg";